import { render, staticRenderFns } from "./NewTagForm.vue?vue&type=template&id=0f0d21c1&"
import script from "./NewTagForm.vue?vue&type=script&lang=js&"
export * from "./NewTagForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports